import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {AnalyticsService} from "../../../Services";
import {connect} from "react-redux";
import SVGInline from "react-svg-inline";

// icons
import endlessSVG from "../../inlineSVGs/endlessSVG";
import starSVG from "../../inlineSVGs/starSVG";
import trophySVG from "../../inlineSVGs/trophySVG";
import ticketsColorSVG from "../../inlineSVGs/ticketsColorSVG";
import viSVG from "../../inlineSVGs/viSVG";
import papillonMugicsSVG from "../../inlineSVGs/papillonMugicsSVG";
import shineSVG from "../../inlineSVGs/shineSVG";

// actions
import {
    closeLoadingModal,
    openConfirmMessageModal,
    openGeneralMessageModal,
    openLoadingModal,
    submitPayment
} from "../../../Actions/main";

// styles
import './PackageOption.css';

// consts
import { ENROL_TYPE_FREE, ENROL_TYPE_HIGH, ENROL_TYPE_HUGE, ENROL_TYPE_MEDIUM } from "../../../Models/consts";
import { createNoEnrollDuplicationMessage } from "../../../Models/strings";
import { downgradePin } from "../../../Actions/users";
import caretDropSharpSVG from "../../inlineSVGs/caretDropSharpSVG";
import { getCurrency, isMobile } from "../../../utils";

// TODO: this will move to admin - TBR
const AD_BOXES_COUNT = {
    free: ['1', '0', '0', '0'],
    mid: ['0', 'Unlimited', '0', '0'],
    high: ['0', '0', 'Unlimited', '0'],
    huge: ['0', '0', 'Unlimited', '2'],
}

const PACKAGES_TYPES = {
    free: [
        [`1 מודעת basic`],
        [`הקפצה ידניות למודעה פעם ביום`],
        [`מיקום על הגריד : #4`]
    ],

    mid: [
        [`מודעות push ללא הגבלה`],
        [`2 הקפצות ידניות למודעה פעם ביום`],
        [`ניתן לבטל בכל עת`],
        [`מיקום על הגריד : #3`]
    ],
    high: [
        [`מודעות RULE ללא הגבלה`],
        [`2 הקפצות ידניות למודעה פעם ביום`],
        [`נקודה גדולה על המפה`, true],
        [`ניתן לבטל בכל עת`],
        [`מיקום על הגריד : #2`],
    ],
    huge: [
        [`2 מודעות hero - בראש העמוד`],
        [`מודעות RULE ללא הגבלה`],
        [`2 הקפצות ידניות למודעה פעם ביום`],
        [`נקודה גדולה על המפה`, true],
        [`העלת כל ההופעות לפלטפורמה מהאתר 
או מעמוד הפייסבוק שלכם `, true, true],
        [`ניתן לבטל בכל עת`],
        [`מיקום על הגריד : #1`]
    ]
}

class PackageOption extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isOpen: false,
            isCurrentPlan: false
        }
    }

    componentWillMount() {
        this.setState({ isCurrentPlan: this.props.userEnrolType === this.props.packageType });
    }

    componentDidUpdate(prevProps) {
        if (prevProps.userEnrolType !== this.props.userEnrolType) {
            this.setState({ isCurrentPlan: this.props.userEnrolType === this.props.packageType });
        }
    }

    getViColor(isPopular, isActive) {
        if (isPopular) return '#ffffff';
        if (isActive) return '#8021fc';
    }

    getPrices(packageType, datatypes) {
        if (!datatypes || !datatypes.packages) return '';

        const packageObj = this.props.datatypes.packages.find(p => p.name === packageType) || {};

        return `${getCurrency(packageObj.currency)}${packageObj.price || 0}`;
    }

    handleSubmit() {
        const pin = JSON.parse(JSON.stringify(this.props.pinDataWaiting || {}));

        if (
            this.props.userEnrolType !== ENROL_TYPE_FREE &&
            this.props.isUserPaid &&
            this.props.packageType === ENROL_TYPE_FREE
        ) {
            this.props.openConfirmMessageModal({
                header: 'רק שניה',
                message: 'את/ה עומד לבטל את המנוי שלך. רק המודעה האחרונה שלך תמשיך להופיע. להמשיך?',
                isCancel: true,
                confirm: () => this.submitSelection(pin, this.props.userEnrolType)
            });

            return;
        }

        this.submitSelection(pin, this.props.userEnrolType)
    }

    submitSelection(pin, userEnrolType) {
        // TODO: add here exeption for user being able to pay for 'Payment Needed' on the same enrolType
        if (userEnrolType) {
            // downgrading to free
            if (userEnrolType !== ENROL_TYPE_FREE && this.props.packageType === ENROL_TYPE_FREE) {

                this.setState({ isOpen: false });
                this.props.downgradePin();
                return;
            }

            // prevent same enroll duplication update
            if (
                userEnrolType === this.props.packageType &&
                userEnrolType === ENROL_TYPE_FREE &&
                !pin.name
            ) {
                const message = createNoEnrollDuplicationMessage();
                this.props.openGeneralMessageModal(message.header, message.body);
                return
            }
        }

        // request to the server endpoint
        this.props.openLoadingModal();

        this.setState({ isLoading: true }, () => {
            this.props.submitPayment(this.props.token, pin, this.props.filesWaiting, this.props.packageType);

            AnalyticsService.sendEvent(AnalyticsService.events.SELECT_PAID_PLAN, `${pin.type}_${this.props.packageType}_${pin.category}`, null, {
                plan_type: this.props.packageType,
                pin_type: pin.type,
                pin_category: pin.category
            })
        });
    }

    handleBoxClick() {
        if (!isMobile()) return;

        this.setState({ isOpen: !this.state.isOpen })
    }

    renderPackageBtn(packageType, popularClass) {
        let btnText = 'התקדם ל - Mugics Premium';

        if (packageType === ENROL_TYPE_FREE) {
            btnText = 'נסה בחינם';
            if (this.props.userEnrolType && this.props.userEnrolType !== ENROL_TYPE_FREE) {
                btnText = 'ביטול מנוי'
            }
        }

        if (packageType === ENROL_TYPE_MEDIUM) {
            if (this.props.userEnrolType === ENROL_TYPE_HIGH || this.props.userEnrolType === ENROL_TYPE_HUGE) {
                btnText = 'שינמוך תוכנית'
            }
        }

        if (packageType === ENROL_TYPE_HIGH) {
            if (this.props.userEnrolType === ENROL_TYPE_HUGE) {
                btnText = 'שינמוך תוכנית'
            }
        }

        if (packageType === ENROL_TYPE_HUGE) {
            btnText = 'התקדם ל - Mugics Business';
        }

        if (this.state.isCurrentPlan && packageType !== ENROL_TYPE_FREE) {
            return (
                <div className={`package-btn-wrapper ${popularClass} ${packageType}`}>
                    <button disabled onClick={() => {}}>{`חבילה נוכחית`}</button>
                </div>
            )
        }

        return (
            <div className={`package-btn-wrapper ${popularClass} ${packageType}`}>
                <button className="enabled" onClick={() => this.handleSubmit()}>{btnText}</button>
            </div>
        )
    }

    renderHeroBanner() {

        return (
            <div className="hero-banner-wrapper">
                <div className="hero-banner-container">
                    <span>כרטיס אחד בחודש מחזיר את ההשקעה שלכם!</span>
                    <SVGInline className={`tickets-icon`} svg={ticketsColorSVG} width={40} component="i"/>
                    <SVGInline style={{top: 12, right: 25}} width={13} className="hero-shine-icon" svg={shineSVG('#ffffff')} component="i" />
                    <SVGInline style={{top: 15, left: 23}} width={10} className="hero-shine-icon" svg={shineSVG('#ffffff')} component="i" />
                    <SVGInline style={{bottom: 5, left: 55}} width={11} className="hero-shine-icon" svg={shineSVG('#ffffff')} component="i" />

                </div>
                <div className="hero-banner-container">
                    <span>2-3 לקוחות שהגיעו דרך mugics והחזרתם</span>
                    <span>את ההשקעה</span>
                    <SVGInline className={`papillon-icon`} svg={papillonMugicsSVG} width={40} component="i"/>
                    <SVGInline style={{top: 12, right: 25}} width={13} className="hero-shine-icon" svg={shineSVG('#ffffff')} component="i" />
                    <SVGInline style={{bottom: 5, left: 55}} width={11} className="hero-shine-icon" svg={shineSVG('#ffffff')} component="i" />
                </div>

            </div>
        )
    }

    renderAdBoxOrder(packageType, popularClass) {
        const adBoxes = AD_BOXES_COUNT[packageType] || {};

        return (
            <div className={`ad-order-wrapper ${popularClass}`}>
                <h3 className="ad-order-title">סדר הופעת המודעות באתר </h3>
                <div className={`ad-order-box-container ${popularClass}`}>
                    <div className={`ad-type-row hero ${packageType === ENROL_TYPE_HUGE ? 'active' : ''} ${adBoxes[3] === 'Unlimited' ? 'small' : ''}`}>
                        <span>Hero ad</span><span className="ad-num">{adBoxes[3]}</span>
                        {adBoxes[3] === 'Unlimited' ? <SVGInline className={`trophy-icon`} svg={trophySVG()} width={25} component="i"/> : null}
                    </div>
                    <div className={`ad-type-row ${packageType === ENROL_TYPE_HIGH || packageType === ENROL_TYPE_HUGE  ? 'active' : ''} ${adBoxes[2] === 'Unlimited' ? 'small' : ''}`}>
                        <span>Rule ad</span><span className="ad-num">{adBoxes[2]}</span>
                        {adBoxes[2] === 'Unlimited' ?
                            <SVGInline
                                className={`endless-icon`}
                                svg={packageType === ENROL_TYPE_HIGH ? endlessSVG('#ffffff') : endlessSVG()}
                                width={25}
                                component="i"
                            /> : null
                        }
                    </div>
                    <div className={`ad-type-row ${packageType === ENROL_TYPE_MEDIUM ? 'active' : ''} ${adBoxes[1] === 'Unlimited' ? 'small' : ''}`}>
                        <span>Push ad</span><span className="ad-num">{adBoxes[1]}</span>
                        {adBoxes[1] === 'Unlimited' ? <SVGInline className={`endless-icon`} svg={endlessSVG()} width={25} component="i"/> : null}
                    </div>
                    <div className={`ad-type-row ${packageType === ENROL_TYPE_FREE ? 'active' : ''} ${adBoxes[0] === 'Unlimited' ? 'small' : ''}`}>
                        <span>Basic ad</span><span className="ad-num">{adBoxes[0]}</span>
                    </div>
                </div>
                <span className="ad-order-label">מודעה יותר גבוהה באתר אומר יותר חשיפה ,קליקים ופניות</span>
            </div>
        )
    }

    render() {
        const { name, isPopular, packageType, datatypes } = this.props;
        const popularClass = isPopular ? 'popular' : ''

        return (
            <div
                className={`package-option-box-container ${popularClass} ${this.state.isCurrentPlan && packageType !== ENROL_TYPE_FREE ? 'disabled' : ''}`}
                onClick={() => this.handleBoxClick()}
            >
                <div className={`package-box ${popularClass} ${this.state.isOpen ? 'open' : ''}`}>
                    {isPopular ?
                        <div className="popular-label">
                            <SVGInline className={`star-icon`} svg={starSVG()} width={10} component="i"/>
                            הכי פופולרי</div>
                        : null
                    }
                    <div className="name-wrapper">
                        <span>{name}</span>
                    </div>
                    <div className={`prices-wrapper ${popularClass}`}>
                        <SVGInline className={`arrow-icon ${this.state.isOpen ? 'open' : ''}`} svg={caretDropSharpSVG} component="i"/>
                        <span className="price">{this.getPrices(packageType, datatypes)}</span>
                        <span className="per-month">לחודש/</span>
                    </div>
                </div>

                <div className={`package-box-content-wrapper ${popularClass} ${packageType}`}>
                    <div className={`package-box-collapsable ${this.state.isOpen ? 'open' : ''}`}>
                        <div className="features-wrapper">
                            {PACKAGES_TYPES[packageType].map((f, i) => {
                                return (
                                    <div key={i} className="feature">
                                        {f[1] ?
                                            <SVGInline className={`vi-icon double`} svg={viSVG(this.getViColor(isPopular, f[2]))} width={10} component="i"/>
                                            : null
                                        }
                                        <SVGInline className={`vi-icon`} svg={viSVG(this.getViColor(isPopular, f[2]))} width={10} component="i"/>
                                        <span className={`feature-text ${f[2] ? 'active' : ''}`}>{f[0]}</span>
                                    </div>
                                )
                            })}
                        </div>
                        {this.renderAdBoxOrder(packageType, popularClass)}
                        {this.renderPackageBtn(packageType, popularClass)}
                        {packageType === ENROL_TYPE_HUGE ? this.renderHeroBanner() : null}
                    </div>
                </div>
            </div>
        )
    }
}

PackageOption.propTypes = {
    token: PropTypes.string,
    datatypes: PropTypes.object,
    name: PropTypes.string,
    price: PropTypes.string,
    isPopular: PropTypes.bool,
    packageClosed: PropTypes.bool,
    packageType: PropTypes.oneOf([
        ENROL_TYPE_FREE,
        ENROL_TYPE_MEDIUM,
        ENROL_TYPE_HIGH,
        ENROL_TYPE_HUGE
    ]),
    userEnrolType: PropTypes.oneOf([
        ENROL_TYPE_FREE,
        ENROL_TYPE_MEDIUM,
        ENROL_TYPE_HIGH,
        ENROL_TYPE_HUGE
    ]),
    isUserPaid: PropTypes.bool,
    pinDataWaiting: PropTypes.object,
    filesWaiting: PropTypes.object,
    openConfirmMessageModal: PropTypes.func,
    downgradePin: PropTypes.func,
    openGeneralMessageModal: PropTypes.func,
    openLoadingModal: PropTypes.func,
    submitPayment: PropTypes.func
};

const mapStateToProps = state => ({
    datatypes: state.main.datatypes,
    token: state.users.token,
    userEnrolType: state.users.subscription && state.users.subscription.enrolType,
    isUserPaid: state.users.subscription && state.users.subscription.isPayed,
    pinDataWaiting: state.users.pinDataWaiting,
    filesWaiting: state.users.filesWaiting
});

export default connect(mapStateToProps, {
    submitPayment,
    openLoadingModal,
    closeLoadingModal,
    openConfirmMessageModal,
    downgradePin,
    openGeneralMessageModal
})(PackageOption);



// WEBPACK FOOTER //
// ./src/Components/ScreenElements/PackageOption/PackageOption.js